import { Component } from "react";
import {
  Col,
  Row,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Modal,
} from "reactstrap";
import {
  AvField,
  AvForm,
} from "availity-reactstrap-validation";
import {
  FileInput,
  generateFormData
} from "../../../helpers/ui/FileInput";
import { ConfirmAlert } from "../../../helpers/ui/alert";
import apiResponse from "../../../services/apiResponse";
import DataTableBloc from "../Index/Blocs/DataTableBloc";

class CloseTicketModal extends Component {
  dataTableBloc = new DataTableBloc();
  userData = JSON.parse(localStorage.getItem("userdata"));

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        agenda_nip: this.userData.employee_nip,
      },
    };
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();

    this.setState({
      confirm_close_ticket: true,
      dataForm: {
        ...this.state.dataForm,
        ...values,
      },
    });

    console.log("values: "+JSON.stringify(values));
  };

  submitData = async () => {
    console.log("data form: "+JSON.stringify(this.state.dataForm));
    const formData = generateFormData(this.state.dataForm, {
      field: "ticket_solved_attachment",
      name: "ticketAttachments/attachment",
    });

    console.log(formData)
    await this.dataTableBloc.fetchCloseTicket(formData);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm_close_ticket: false,
        };
        break;
      case "confirm":
        forState = {
          loading_close_ticket: true,
          confirm_close_ticket: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success_close_ticket: false,
          redirect_close_ticket: true,
        };
        break;
      case "failed":
        forState = {
          failed_close_ticket: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.dataTableBloc.closeTicketChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading_close_ticket: false,
            success_close_ticket: true,
          });
          setTimeout(() => {
            this.setState({
              success_close_ticket: false,
            });
            this.props.toggleModal();
          }, 1200);
          break;
        case apiResponse.ERROR:
          this.setState({
            loading_close_ticket: false,
            failed_close_ticket: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.closeTicketChannel.unsubscribe();
  }

  renderCardForm = () => {
    return (
      <>
        <Card className="m-0">
          <CardBody>
            <CardTitle>Tutup Tiket</CardTitle>
            <CardSubtitle className="mb-3">
              Tutup tiket dengan mengisi form di bawah ini
            </CardSubtitle>
            <hr />
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
              onKeyPress={this.preventEnter}
            >

              <AvField
                name="ticket_uuid"
                type="hidden"
                id="ticket_uuid"
                value={this.props.ticketUuid}
              />
              <Row>
                <label
                  htmlFor="current_file_name"
                  className="col-md-3 col-form-label"
                >
                  Root Cause
                </label>
                <Col md="9">
                  <AvField
                    name="ticket_root_cause"
                    type="text"
                    className="form-control"
                    id="ticket_root_cause"
                  />
                </Col>
              </Row>

              <br></br>

              <Row>
                <label
                  htmlFor="current_file_name"
                  className="col-md-3 col-form-label"
                >
                  Action
                </label>
                <Col md="9">
                  <AvField
                    name="ticket_action"
                    type="text"
                    className="form-control"
                    id="ticket_action"
                  />
                </Col>
              </Row>

              <br></br>

              <Row>
                <label
                  htmlFor="current_file_name"
                  className="col-md-3 col-form-label"
                >
                  Solved Time <span className="text-danger">*</span>
                </label>
                <Col md="9">
                  <AvField
                    name="ticket_solved_time"
                    type="datetime-local"
                    errorMessage="Masukkan Solved Time"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="ticket_solved_time"
                  />
                </Col>
              </Row>

              <br></br>
              
              <Row>
                <label
                  htmlFor="agenda_location"
                  className="col-md-3 col-form-label"
                >
                  File 
                </label>
                <br></br>
                <Col md="9">
                  <FileInput
                    name="ticket_solved_attachment"
                    accept=".pdf,.jpg,.png,.jpeg"
                  />
                  <p style={{ fontWeight: 500 }} className="text-secondary">
                    Format file yang diijinkan: .pdf, .jpg, .png, dan .jpeg
                  </p>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md="3"></Col>
                <Col md="9">
                  <Button
                    color="danger"
                    onClick={this.props.toggleModal}
                  >
                    <i className="uil-arrow-left"></i> Kembali
                  </Button>{" "}
                  <Button color="success" type="submit">
                    <i className="uil-save"></i> Simpan
                  </Button>
                </Col>
              </Row>
            </AvForm>
          </CardBody>
        </Card>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm_close_ticket}
          showLoading={this.state.loading_close_ticket}
          showSuccess={this.state.success_close_ticket}
          showFailed={this.state.failed_close_ticket}
          response={this.confirmResponse}
        />
      </>
    );
  };

  render() {
    return (
      <Modal
        centered
        size="lg"
        toggle={this.props.toggleModal}
        isOpen={this.props.showModal}
        backdrop="static"
      >
        {this.props.showModal ? this.renderCardForm() : null}
      </Modal>
    );
  }
}

export default CloseTicketModal;
